import { usePassportProvider } from "@/context";
import { delay } from "@/utils/util";
import { usePrevious } from "@biom3/react";
import type { Content } from "@prismicio/client";
import type { QuestGroup } from "@ui-kit/QuestList";
import { isEqual } from "lodash";
import { useEffect } from "react";
import { useGetWalletLatestEarnings } from "../api";
import { useInitialiseQuestGroup } from "./useInitialiseQuestGroup";

export const useOnboardingQuests = (
  game: Content.GameDocument,
  questGroups: QuestGroup[],
  isWishlisted: boolean,
) => {
  const { walletAddress } = usePassportProvider();
  const { latestEarnings, mutate: mutateGetEarnings } =
    useGetWalletLatestEarnings(walletAddress);
  const previousEarnings = usePrevious(latestEarnings) || undefined;

  const { reInitialiseQuestGroup } = useInitialiseQuestGroup(
    walletAddress,
    game,
    questGroups,
    latestEarnings,
  );

  // If user clicks "Follow me" button we need to mutate the earnings
  // and manually initialise the QuestGroups.
  useEffect(() => {
    if (!isWishlisted) return;
    (async () => {
      await delay(1000);
      mutateGetEarnings();
    })();
  }, [isWishlisted, mutateGetEarnings]);

  // If latestEarnings changes initialise the QuestGroupState
  useEffect(() => {
    if (!isEqual(latestEarnings, previousEarnings) && isWishlisted) {
      reInitialiseQuestGroup();
    }
  }, [latestEarnings, previousEarnings, reInitialiseQuestGroup, isWishlisted]);
};
